import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { WriteUpDetailComponent } from "src/app/feature/writeups-detail/writeup-detail-page/writeup-detail-page";
import { WebSocketManagerService } from "./websocket-manager.service";

@Injectable({
    providedIn: 'root'
})
export class CanDeactivateService {
    constructor(private readonly socketManager: WebSocketManagerService){}
    canDeactivate(component: WriteUpDetailComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot): boolean {
        this.socketManager.triggerDealLeftEvent()
        return true;
    }
}